// GA-11 por años (bloque 7, B2; §17 ítem 103): el informe de gestión del
// Organismo Paritario es anual (vigencia hasta el 31 de enero del año siguiente,
// DE 255 Art. 39, vigencias-sso.ts). Igual que GA-07 por meses: un año cuenta si
// hay un informe GA-11 cuyo "Aprobado desde" cae en ese año; la fecha de carga no
// cuenta. Se cuentan también las versiones archivadas.

import type { InformeGA07 } from './ga07-meses';

export type InformeGA11 = InformeGA07;

export type EstadoAnio = 'con_informe' | 'falta';

export interface AnioGA11 {
  anio: number;
  estado: EstadoAnio;
  informe: InformeGA11 | null;
}

/** Años que se muestran: los últimos `cuantos` hasta el actual y los anteriores que tengan informe. */
export const ANIOS_GA11 = 5;

function mejor(a: InformeGA11, b: InformeGA11): InformeGA11 {
  if (a.is_current !== b.is_current) return a.is_current ? a : b;
  return a.created_at >= b.created_at ? a : b;
}

export function aniosGA11(informes: InformeGA11[], hoy: string, cuantos = ANIOS_GA11): AnioGA11[] {
  const actual = Number(hoy.slice(0, 4));
  const porAnio = new Map<number, InformeGA11>();
  for (const inf of informes) {
    if (!inf.approved_from) continue;
    const a = Number(inf.approved_from.slice(0, 4));
    const previo = porAnio.get(a);
    porAnio.set(a, previo ? mejor(previo, inf) : inf);
  }
  const anios = new Set<number>();
  for (let a = actual - cuantos + 1; a <= actual; a++) anios.add(a);
  porAnio.forEach((_, a) => { if (a <= actual) anios.add(a); });
  return Array.from(anios).sort((x, y) => x - y).map(anio => {
    const informe = porAnio.get(anio) ?? null;
    return { anio, estado: informe ? 'con_informe' : 'falta', informe };
  });
}

/** "Aprobado desde" al subir desde un año vacío: el 1 de enero de ese año. */
export function primerDiaAnio(anio: number): string {
  return `${anio}-01-01`;
}
